import { ButtonBase } from './ButtonBase';
import styled from 'styled-components';

export const PrimaryButton = styled(ButtonBase)`
    background: #2C2C2C;
    color: #fff;
    border-radius: 4px;
`